import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`
    width: 100%;
    padding: 10px 0 1em;
    z-index: 99999;
    transition: opacity 200ms ease, transform 200ms ease;

    pointer-events: none;
    opacity: 0;
    transform: translateY(100%) scale(0.8);

    &.visible {
        pointer-events: all;
        opacity: 1;
        transform: translateY(0) scale(1);
    }
    
    &.position-relative {
        position: relative;
    }

    &.position-fixed {
        position: fixed;
        bottom: 0;
    }

    &.shouldHide {
        opacity: 0;
    }

    &.isHidden {
        .promo-bar-container {
            height: 20px;
            overflow: hidden;
            opacity: 0.7;

            .promo-bar-row-content {
                .promo-bar-left-col,
                .promo-bar-right-col {
                    opacity: 0;
                }
            }

            .promo-bar-hide-button {
                opacity: 1;
                pointer-events: all;
                transform: translateY(0) scale(0.8);

                .chevron {
                    transform: rotate(180deg);
                }
            }
        }
    }

    .promo-bar-container {
        background-color: #303030;
        background-image: url("/images/article/promo-bar-bg.svg");
        background-repeat: no-repeat;
        background-size: cover;
        border-radius: 0.6em;
        z-index: 1;

        .promo-bar-hide-button {
            position: absolute;
            top: -40px;
            right: 0;
            width: 30px;
            height: 30px;
            border-radius: 30px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #FFFFFF;
            border: 1px solid #BA9449;
            cursor: pointer;
            opacity: 0;
            pointer-events: none;
            transform: translateY(20px) scale(0.8);
            transition: opacity 200ms ease, transform 200ms ease;
            z-index: 0;
            
            .chevron {
                width: 16px;
                height: 16px;
            }

            &:after {
                position: absolute;
                content: '';
                width: 180%;
                height: 180%;
                left: -40%;
                bottom: -40%;
            }
        }

        @media (pointer: fine) {
            &:hover {
                &:after {
                    position: absolute;
                    content: '';
                    height: 30px;
                    width: 100%;
                    background-color: transparent;
                    top: -30px;
                    z-index: -1;
                }

                .promo-bar-hide-button {
                    opacity: 1;
                    pointer-events: all;
                    transform: translateY(0) scale(0.8);
                }
            }
        }

        .promo-bar-row-content {
            display: flex;
            justify-content: space-between;
            align-items: stretch;
            padding: 1.5em;

            .promo-bar-left-col {
                line-height: 1.2;

                .headline {
                    color: #FFFFFF;
                    font-size: 1.3em;
                }

                .subheadline {
                    color: #BA9449;
                    font-size: 1.3em;
                    font-weight: 700;
                }
            }

            .promo-bar-right-col {
                display: flex;
                align-items: stretch;
                gap: 1.4em;

                .layout-button {
                    align-items: stretch;
                    transform-origin: right;
                    transition: transform 100ms ease;

                    @media (pointer: fine) {
                        &:hover {
                            transform: scale(1.1);
                        }
                    }

                    .button {
                        align-items: center;
                        font-size: 1em;
                        font-weight: 700;
                    }
                }
            }
        }
    }

    @media all and (max-width: ${variables.mobileL}) {
        .promo-bar-container {
            .promo-bar-row-content {
                flex-direction: column;

                .promo-bar-left-col {
                    text-align: center;
                }

                .promo-bar-right-col {
                    padding-top: 1em;
                    align-items: center;
                    justify-content: center;
                    font-size: 1.6em;

                    .layout-button {

                        @media (pointer: fine) {
                            &:hover {
                                transform: scale(1);
                            }
                        }
                    }
                }
            }
        }
    }
`;
